export default "__VITE_ASSET__DcqBYAU7__"